
export default {
    declaration: {
        preferredChannels: [],
        consents: '',
        agreeAllTerms: false,
        ackTncIndicator: false,
        additionalDeclarationConsent: false,
    }
}
